module.exports = __webpack_public_path__ + "img/help.c71bf126.png";